<template>
	<div
		class="relative flex items-center justify-center bg-center p-5 py-0 sm:w-full md:max-h-[380px] md:p-10"
	>
		<NuxtImg
			:src="'/images/off-market-card-bg.webp'"
			class="absolute z-10 size-full grayscale"
			width="500"
			height="380"
			sizes="xs:375px sm:500px"
			densities="x1"
			format="webp"
			loading="lazy"
		/>
		<Card
			:class="
				cn(
					'z-20 flex h-[260px] w-full flex-col items-start justify-center bg-primary md:h-[288px]',
					cardClass
				)
			"
		>
			<CardHeader class="px-5 pb-3 pt-9 md:px-6 md:pb-5 md:pt-4">
				<CardTitle
					class="flex flex-col gap-2 text-[22px] font-light tracking-[-0.02rem] text-white md:flex-row md:items-center md:gap-0 md:text-2xl"
				>
					<GraphicsTriangle class="mr-4 size-4 text-white md:h-5 md:w-[19px]" />
					{{ props.title }}
				</CardTitle>
			</CardHeader>
			<CardContent
				class="px-6 pb-6 font-sans text-[14px] font-normal leading-[1.75] tracking-[-0.02rem] text-white md:text-base"
			>
				<p>{{ props.description }}</p>
			</CardContent>
			<CardFooter class="px-6 pb-7">
				<div
					class="size-full max-h-[44px] max-w-[197px] md:max-h-[48px] md:max-w-[228px]"
				>
					<NuxtLink
						v-slot="{ href }"
						:to="props.ctaDestinationUrl"
						custom
						@click="handleOffMarketCardClicked()"
					>
						<Button
							as="a"
							:href="href"
							size="md"
							variant="secondary-dark"
							:class="
								cn(
									props.buttonClass,
									'min-w-fit border-primary-light-3 text-sm md:text-base'
								)
							"
						>
							{{ props.ctaText }}
							<IconMaterialSymbolsLightNorthEast class="size-5" />
						</Button>
					</NuxtLink>
				</div>
			</CardFooter>
		</Card>
	</div>
</template>
<script setup lang="ts">
import type { DiscoverPropertiesCardEmits } from '.';

import { cn } from '@/utils';

import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardTitle
} from '../ui/card';

const emit = defineEmits<DiscoverPropertiesCardEmits>();

function handleOffMarketCardClicked() {
	emit('cta_clicked', {
		cta_text: 'Ver todos os imóveis',
		destination_url: '/venda/imoveis/sao-paulo-sp-brasil'
	});
}

const props = withDefaults(
	defineProps<{
		title?: string;
		description?: string;
		ctaText?: string;
		ctaDestinationUrl?: string;
		buttonClass?: string;
		cardClass?: string;
	}>(),
	{
		title: 'Descubra mais imóveis',
		description: 'Explore nosso portfólio completo e encontre o imóvel ideal.',
		ctaText: 'Ver todos os imóveis',
		ctaDestinationUrl: '/venda/imoveis/sao-paulo-sp-brasil',
		buttonClass: 'min-w-fit border-primary-light-3 text-sm md:text-base',
		cardClass: 'h-[215px]'
	}
);
</script>
